<template>
    <section id="welcome-party">
        <h2>Welcome Party</h2>
        <div class="welcome-party-content">
            <div class="welcome-party-text">
                <p class="mb-4">
                    For those of you who will be in the area on the night before the wedding, we would love to invite you to a welcome party at the clubhouse at Providence Country Estate.
                </p>

                <p class="mb-4">
                    If you would like to join, the approximate start time will be 5pm and we will aim to all be in bed by 9pm - the bride needs her beauty sleep!
                </p>

                <p>
                    This will be a very casual event so please bring your own food and drinks. There will be braai facilities for those who wish to use them. We will provide a selection of salads.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "WelcomePartySection",
}
</script>

<style scoped>
.welcome-party-content {
    max-width: 800px;
    margin: 0 auto;
    padding-top: 2rem;
}

.welcome-party-text {
    line-height: 1.8;
    font-size: 1.1rem;
    color: #333;
}

.welcome-party-text p {
    margin-bottom: 1.5rem;
}

.welcome-party-text p:last-child {
    margin-bottom: 0;
}

@media (max-width: 768px) {
    .welcome-party-text {
        font-size: 1rem;
        line-height: 1.6;
    }

    .welcome-party-content {
        padding: 1rem 0;
    }
}
</style>
